import { render, staticRenderFns } from "./ClientReferalMobile.vue?vue&type=template&id=4304c7ee"
import script from "./ClientReferalMobile.vue?vue&type=script&lang=js"
export * from "./ClientReferalMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports